import { RenalDetectRecommendation } from '@app/core/models';
import { StateNamesEnum } from '@app/shared/utils/enums/state-names.enum';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConsultationState } from './consultation.state';

export const selectConsultation = createFeatureSelector<ConsultationState>(StateNamesEnum.CONSULTATION_STATE_NAME);

export const selectConsultationPatient = createSelector(selectConsultation, (state: ConsultationState) => state.patient);
export const selectConsultationPetOwner = createSelector(selectConsultation, (state: ConsultationState) => state.petOwner);
export const selectConsultationRenalDetectRecommendation = createSelector(
  selectConsultation,
  (state: ConsultationState) => state.renalDetectRecommendation,
);
export const selectConsultationRenalDetectPrediction = createSelector(
  selectConsultationRenalDetectRecommendation,
  (recommendation: RenalDetectRecommendation) => recommendation?.prediction,
);
export const selectLastConsultation = createSelector(selectConsultation, (state: ConsultationState) => state.lastConsultation);
export const selectCurrentConsultation = createSelector(selectConsultation, (state: ConsultationState) => state.currentConsultation);

export const selectCreatingConsultation = createSelector(
  selectConsultation,
  (state: ConsultationState) => state.creatingCurrentConsultation,
);

export const selectExpectedNextVisit = createSelector(selectConsultation, (state: ConsultationState) => state.expectedNextVisit);

export const selectSkipProductBook = createSelector(selectConsultation, (state: ConsultationState) => state.skipProductBook);
export const selectVetSourceOrderStatus = createSelector(selectConsultation, (state) => state.vetSourceOrderStatus);
export const selectIsWLPEligible = createSelector(selectConsultation, (state: ConsultationState) => state.isWLPEligible);
export const selectIsWLPIncluded = createSelector(selectConsultation, (state: ConsultationState) => state.isWLPIncluded);
